<div class="container-fluid" style="max-height: 75vh; overflow-y: auto;">

  <div class="row" style="margin: 0px;padding: 0px;">

    <div class="text-center col-sm-12" style="background-color: gray;max-width: 98% !important;">
      <h2 style="color: white; text-align: center;">Rollback Configuration for {{systemIpAndName.system_name}}</h2>
    </div>

    <div class="col-sm-3 configFilesHeader">
      <h2 style="width: 100%;background-color: black;color:white">Configuration Files Available</h2>
      <mat-selection-list #file [(ngModel)]="rolledBackSelectedName" [multiple]="false"
                                      (ngModelChange)="onNgModelChange($event)" color="#FFF176">
        <mat-list-option *ngFor="let fileName of listOfFIlesNames" [value]="fileName">
          {{fileName}}
        </mat-list-option>
      </mat-selection-list>

    </div>

    <div class="col-sm-9">
      <div class="col-sm-12 configFilesHeader" style="background-color: bisque;max-height:50vh;overflow-y:auto;">
        <h2 style="width: 100%;background-color: black;color:white">Current System Configuration: {{currentConfigName}}</h2>
        <div *ngIf="currentConfigString" class="xmlAdjust">
          <xml-viewer-component xml= {{currentConfigString}}
          ></xml-viewer-component>
        </div>
      </div>

      <div class="col-sm-12 configFilesHeader" style="background-color: lavender;max-height:50vh;overflow-y:auto;">
        <h2 style="width: 100%;background-color: black;color:white">
          Selected Rollback System Configuration: {{rolledBackSelectedName?rolledBackSelectedName:"no file selected"}}</h2>
        <p class="xmlAdjust" *ngIf="!rolledBackSelectedString">
          Select a file to preview from the configuration files available list
        </p>
        <div *ngIf="rolledBackSelectedString" class="xmlAdjust">
          <xml-viewer-component xml= {{rolledBackSelectedString}}
          ></xml-viewer-component>
        </div>
      </div>
    </div>

    <div class="col-sm-12">
      <div mat-dialog-actions class="col" style="display: flex;justify-content: center;">
        <button class="btn btn-primary"
        [disabled]="!rolledBackSelectedName || !currentConfigName" (click)="onYesClick()">Confirm Rollback
        </button>
        <button class="btn btn-danger"  (click)="onNoClick()">Cancel</button>
      </div>
    </div>


    <div id="closeBtn">
      <mat-icon aria-hidden="false" class="fa-2x"  style="width: 100%; color: black;"
      id="closeBtn" (click)="onNoClick()">close</mat-icon>
    </div>

  </div>

</div>
